var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("u3-video", _vm._b({}, "u3-video", _vm.result, false))
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }